/**
 * The live step's gate in the flow bar (#1217, specs/facilitator-console.md →
 * Decision 1): ✓ when every gate check of the live module is met, ⚠ with a
 * count when not. Pressing it opens the step's console (the section). Nothing
 * when the module declares no gate checks. Platform component.
 */
import React from 'react';
import styled from '@emotion/styled';
import { AlertTriangle, Check } from 'lucide-react';
import { useTranslation } from '../../hooks/useTranslation.jsx';

const Badge = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin: 0 12px 8px;
  min-height: 32px;
  padding: 0 12px;
  border-radius: 999px;
  font: inherit;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid ${(p) => (p.$unmet ? 'rgba(251, 191, 36, 0.5)' : 'rgba(110, 231, 183, 0.4)')};
  background: ${(p) => (p.$unmet ? 'rgba(251, 191, 36, 0.12)' : 'rgba(16, 185, 129, 0.1)')};
  color: ${(p) => (p.$unmet ? '#fcd34d' : '#a7f3d0')};
  svg { flex-shrink: 0; }
`;

/**
 * @param {{ checks: Array<{ satisfied: boolean }>, onOpen: Function }} props
 *   `checks` are the live step's evaluated gate checks.
 */
export default function GateBadge({ checks = [], onOpen }) {
  const { t } = useTranslation();
  if (!checks.length) return null;
  const unmet = checks.filter((c) => !c.satisfied).length;
  return (
    <Badge type="button" $unmet={unmet > 0} onClick={onOpen} title={t('workshopOrchestrator.gate.open')}>
      {unmet ? <AlertTriangle size={14} /> : <Check size={14} />}
      {unmet ? t('workshopOrchestrator.gate.unmet', { count: unmet }) : t('workshopOrchestrator.gate.ok')}
    </Badge>
  );
}
